import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    createOutdoorsLocalizationScreen({ commit }, payload) {
        return axios
            .post('/outdoors/outdoor-localization-screens', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Ekran został dodany.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie ekranu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateOutdoorsLocalizationScreen({ commit }, payload) {
        return axios
            .put(`/outdoors/outdoor-localization-screens/${payload.id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zapis powiódł się.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zapis nie powiódł się.')

                return Promise.reject(error)
            })
    },
    deleteOutdoorsLocalizationScreen({ commit }, id) {
        return axios
            .delete(`/outdoors/outdoor-localization-screens/${id}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Usunięcie powiodło się.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie nie powiodło się.')

                return Promise.reject(error)
            })
    }
}